import { render, staticRenderFns } from "./ChatAnswer.vue?vue&type=template&id=397c9ea2"
import script from "./ChatAnswer.vue?vue&type=script&lang=js"
export * from "./ChatAnswer.vue?vue&type=script&lang=js"
import style0 from "./ChatAnswer.vue?vue&type=style&index=0&id=397c9ea2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports